export class BasePersistor {
  protected hasValidValue = (value: string | any[]) => {
    if (Array.isArray(value) && !value.length) {
      return false;
    }

    return value;
  };

  protected getSavingDirectory = (directory: string, folderName: string) => {
    let IsNotSavingInFolder = !folderName;
    return IsNotSavingInFolder
      ? directory
      : `${!directory ? "" : directory + "/"}${folderName}`;
  };

  protected getInputValue = (inputValue: any) => {
    return !(inputValue === 0) && (!inputValue || (Array.isArray(inputValue) && !inputValue?.length)) ? undefined : inputValue;
  }
}
